import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const AleaLoader: React.FC = () => {
  // Define animations
  const float = keyframes`
    0%, 100% {
      transform: translate(-50%, -52%);
    }
    50% {
      transform: translate(-50%, -48%);
    }
  `;

  const glowFade = keyframes`
    0%, 100% {
      filter: drop-shadow(0 0 0px #7454FF);
    }
    50% {
      filter: drop-shadow(0 0 10px #7454FF);
    }
  `;

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      background="rgba(255, 255, 255, 0.5)"
      zIndex="9999"
    >
      <Box
        position="fixed"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="120px"
        height="120px"
        zIndex="9999"
        pointerEvents="none"
        animation={`${float} 2.5s ease-in-out infinite`}
        className="alea-logo-wrapper"
        opacity={0.5}
      >
        <svg
          width="120"
          height="120"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="logo-parts">
            <path
              d="M45.7603 20.0498C38.1103 24.1198 35.1803 33.7098 39.2503 41.3598L56.3003 73.4398C60.3703 81.0898 69.9603 84.0198 77.6103 79.9498C85.2603 75.8798 88.1903 66.2998 84.1203 58.6498L67.0703 26.5698C63.0003 18.9198 53.4103 15.9898 45.7603 20.0598"
              fill="#7454FF"
              style={{
                transformOrigin: 'center',
                animation: `${glowFade} 3s ease-in-out infinite`,
              }}
            />
            <path
              d="M35.04 42.3201C34.23 40.7901 33.4 37.7901 33.23 34.7801C33.1 32.4601 33.41 31.3301 33.82 28.7601C33.99 27.7201 32.57 27.2401 32.08 28.1701C28.29 35.2901 23.96 43.4101 20.4 50.1001C18.43 53.8001 16.17 57.4501 15.02 60.4801C14.2 62.6401 14.04 64.4001 14.04 66.0301C14.04 74.7101 21.12 81.7801 29.8 81.7801C38.48 81.7801 45.6 74.6901 45.53 66.0101C45.49 61.5801 43.76 58.6801 41.91 55.2801C38.62 49.2401 35.03 42.3201 35.03 42.3201"
              fill="#7454FF"
              style={{
                transformOrigin: 'center',
                animation: `${glowFade} 3s ease-in-out infinite`,
                animationDelay: '0.5s',
              }}
            />
          </g>
        </svg>
      </Box>
    </Flex>
  );
};

export default AleaLoader;
